/* assets/portal-menu-labels.js — PORTAL-zh-tw-LABELS-02
   Owner: zh-TW label normalizer for theme-side customer / order portal surfaces.
   Boundary: theme DOM labels only; does not touch Customer Account UI Extension, checkout, order data, GFun ledger, role, entitlement or delivery state.
   Presentation rule: user-facing navigation uses Workspace/Experience language rather than raw account-role taxonomy. */
(function () {
  'use strict';

  var ROOT_SELECTOR =
    '[data-portal-zh-tw-label-scope], [data-customer-account-workspace], [data-order-delivery-status], [data-customer-entitlement-workspace]';

  var LABELS = {
    Create: '記錄',
    Cards: '任務卡',
    Orders: '服務申請',
    Downloads: '下載',
    Rewards: 'GFun',
    Local: '本機',
    'Guest mode': '訪客模式',
    'Local cards': '本機任務卡',
    'Shopify orders': '服務申請',
    'Saved services': '已保存服務',
    'Last service used': '最近使用服務',
    'View service': '查看服務',
    'Sign out': '登出',
    'Account status': '帳戶狀態',
    'Account entitlement': '帳戶權益',
    'Subscription tier': '方案等級',
    'Account type': '工作區',
    Workspace: '工作區',
    'Preferred category': '偏好服務類別',
    'Demo access': 'Demo 權限',
    'Open demo →': '打開 Demo →',
    'Upgrade →': '升級 →',
    'View order': '查看申請',
    Support: '聯絡專員',
    Dashboard: '查看進度',
    'My Works': '我的作品',
    'Back to dashboard': '返回 Dashboard',
    'Sign in': '登入',
    'Buy again': '再次申請',
    Reorder: '再次申請',
    Order: '申請',
    Fulfilled: '已完成',
    Unfulfilled: '處理中',
    'Partially fulfilled': '部分處理中',
    Shipped: '交付中',
    'Out for delivery': '交付中',
    Delivered: '已完成',
    Pending: '待處理',
    Paid: '已付款',
    Refunded: '已退款',
    Voided: '已取消',
  };

  function localeCode() {
    return String(document.documentElement.lang || '')
      .trim()
      .toLowerCase();
  }

  function isTraditionalChinese() {
    var locale = localeCode();
    return (
      locale === 'zh-tw' ||
      locale.indexOf('zh-tw-') === 0 ||
      locale === 'zh-hk' ||
      locale.indexOf('zh-hk-') === 0 ||
      locale === 'zh-hant' ||
      locale.indexOf('zh-hant-') === 0
    );
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function replaceTextNode(node) {
    var text = normalizeText(node.textContent);
    if (!text || !Object.prototype.hasOwnProperty.call(LABELS, text)) return;
    node.textContent = node.textContent.replace(text, LABELS[text]);
  }

  function walk(root) {
    if (!(root instanceof HTMLElement)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.parentElement) return NodeFilter.FILTER_REJECT;
        if (/^(SCRIPT|STYLE|TEXTAREA|INPUT)$/i.test(node.parentElement.tagName))
          return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceTextNode);
  }

  function run(scope) {
    if (!isTraditionalChinese()) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(ROOT_SELECTOR).forEach(walk);
    if (root.matches && root.matches(ROOT_SELECTOR)) walk(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        run(document);
      },
      { once: true }
    );
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event && event.target ? event.target : document);
  });
})();
